<template>
  <el-dialog title="VIP设置" :visible.sync="visible" width="500px" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="用户昵称">
        <el-input v-model="user.nickname" disabled />
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="user.phone" disabled />
      </el-form-item>

      <!-- VIP状态 -->
      <el-form-item label="VIP状态" prop="is_vip">
        <el-radio-group v-model="form.is_vip">
          <el-radio :label="0">非会员</el-radio>
          <el-radio :label="1">会员</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- VIP到期时间 -->
      <el-form-item
        label="到期时间"
        prop="vip_expire_time"
        v-if="form.is_vip === 1"
      >
        <el-radio-group v-model="vipTimeType" @change="handleVipTimeTypeChange">
          <el-radio label="permanent">永久会员</el-radio>
          <el-radio label="custom">自定义时间</el-radio>
        </el-radio-group>

        <el-date-picker
          v-if="vipTimeType === 'custom'"
          v-model="form.vip_expire_time"
          type="datetime"
          placeholder="选择到期时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%; margin-top: 10px;"
          :picker-options="datePickerOptions"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { setVip } from '@/api/user'

export default {
  name: 'SetVipDialog',
  data() {
    return {
      visible: false,
      submitting: false,
      user: {},
      vipTimeType: 'custom', // permanent: 永久, custom: 自定义
      form: {
        user_id: 0,
        is_vip: 0,
        vip_expire_time: ''
      },
      rules: {
        is_vip: [
          { required: true, message: '请选择VIP状态', trigger: 'change' }
        ],
        vip_expire_time: [
          {
            validator: (rule, value, callback) => {
              if (this.form.is_vip === 1 && this.vipTimeType === 'custom') {
                if (!value) {
                  callback(new Error('请选择到期时间'))
                } else {
                  // 验证到期时间必须大于当前时间
                  if (new Date(value) <= new Date()) {
                    callback(new Error('到期时间必须大于当前时间'))
                  } else {
                    callback()
                  }
                }
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      datePickerOptions: {
        disabledDate(time) {
          // 禁用过去的时间
          return time.getTime() < Date.now() - 8.64e7
        }
      }
    }
  },
  methods: {
    open(user) {
      this.user = { ...user }
      this.form.user_id = user.id
      this.form.is_vip = user.is_vip || 0
      this.form.vip_expire_time = user.vip_expire_time || ''

      // 如果已过期或非会员,默认自定义时间
      if (this.form.is_vip === 0) {
        this.vipTimeType = 'custom'
        // 默认设置一年后到期
        const defaultExpireTime = new Date()
        defaultExpireTime.setFullYear(defaultExpireTime.getFullYear() + 1)
        this.form.vip_expire_time = this.formatDate(defaultExpireTime)
      } else {
        // 根据现有数据设置
        if (!this.form.vip_expire_time) {
          this.vipTimeType = 'permanent'
        } else {
          this.vipTimeType = 'custom'
        }
      }

      this.visible = true
    },
    handleVipTimeTypeChange(value) {
      if (value === 'permanent') {
        this.form.vip_expire_time = ''
      } else {
        // 默认设置一年后到期
        const defaultExpireTime = new Date()
        defaultExpireTime.setFullYear(defaultExpireTime.getFullYear() + 1)
        this.form.vip_expire_time = this.formatDate(defaultExpireTime)
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.submitting = true
          try {
            const params = {
              user_id: this.form.user_id,
              is_vip: this.form.is_vip,
              vip_expire_time: this.vipTimeType === 'permanent' ? null : this.form.vip_expire_time
            }
            const res = await setVip(params)
            if (res.code === 200) {
              this.$message.success('设置成功')
              this.visible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.msg || '设置失败')
            }
          } catch (error) {
            this.$message.error(error.message || '设置失败')
          } finally {
            this.submitting = false
          }
        }
      })
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
:deep(.el-date-picker) {
  width: 100%;
}
</style>
